const MIN_PADDING_VALUE = 10;
// Add 0 in front of time when the value is less than 10, eg: 03
export const Pad = (time) => time < MIN_PADDING_VALUE ? '0' + time.toString() : time.toString();
// To format display time in format : "HH hours and MM minutes"
export const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    return { hours, minutes };
};
//# sourceMappingURL=date-time.js.map